import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import { ProfileImage } from '../../../assets';
import { getAvatarUrl } from '../../../utils/axiosInstance';
import { CHAT_FONT, chatColors } from './chatTheme';

type Props = {
	avatarFileId: string | null | undefined;
	/** Pixel size of the disc, ring included. */
	size: number;
	scale: number;
	/** Unread messages: a red count on the ring's corner. */
	unread?: number;
};

/**
 * A player's picture in the inbox's gold-ringed disc, or the Social cards' silhouette when they
 * have none.
 */
export const ChatAvatar = ({ avatarFileId, size, scale, unread = 0 }: Props) => {
	const ring = Math.max(1, 2 * scale);
	const badge = 18 * scale;

	return (
		<View
			style={[
				styles.ring,
				{ width: size, height: size, borderRadius: size / 2, borderWidth: ring },
			]}
		>
			<Image
				source={avatarFileId ? { uri: getAvatarUrl(avatarFileId) } : ProfileImage}
				style={{
					width: size - ring * 2,
					height: size - ring * 2,
					borderRadius: (size - ring * 2) / 2,
				}}
				resizeMode='cover'
			/>
			{unread > 0 ? (
				<View
					style={[
						styles.badge,
						{
							top: -3 * scale,
							right: -4 * scale,
							minWidth: badge,
							height: badge,
							borderRadius: badge / 2,
							borderWidth: Math.max(1, 1.5 * scale),
							paddingHorizontal: 4 * scale,
						},
					]}
				>
					<Text
						numberOfLines={1}
						style={[styles.badgeText, { fontSize: 11 * scale, lineHeight: 13 * scale }]}
					>
						{unread > 99 ? '99+' : unread}
					</Text>
				</View>
			) : null}
		</View>
	);
};

const styles = StyleSheet.create({
	ring: {
		borderColor: chatColors.buttonRim,
		backgroundColor: chatColors.sunken,
		alignItems: 'center',
		justifyContent: 'center',
	},
	badge: {
		position: 'absolute',
		borderColor: chatColors.sunken,
		backgroundColor: chatColors.unread,
		alignItems: 'center',
		justifyContent: 'center',
	},
	badgeText: {
		fontFamily: CHAT_FONT,
		fontWeight: '800',
		color: '#FFFFFF',
		includeFontPadding: false,
	},
});

export default ChatAvatar;
